import type { JiraNavigationItemTypeKey } from '@atlassian/jira-relay/src/__generated__/ContainerNavigationTabs_container.graphql';

export const CONTENT_MIN_WIDTH = 600;

export const INDIVIDUAL_APP_ITEM_TYPE: Extract<JiraNavigationItemTypeKey, 'APP'> = 'APP';

export const TEAM_NAME = 'Navigation';
